import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from "@angular/router";
import { Itinerary } from "./../itineray.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-itinerary-reservations-trains",
  templateUrl: "./itinerary-reservations-trains.component.html",
  styleUrls: ["./itinerary-reservations-trains.component.css"]
})
export class ItineraryReservationsTrainsComponent implements OnInit {
  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.trains.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeTrain($event, train) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo treno?")) {
      const idx = this.itinerary.reservations.trains.indexOf(train);
      this.itinerary.reservations.trains.splice(idx, 1);
      this.snackBar
        .open("Treno eliminato.", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.trains.splice(idx, 0, train);
          this.snackBar.open(
            "Il treno che avevi eliminato è stato inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addTrain() {
    this.itinerary.reservations.trains.push({
      id: uuid(),
      notes: null,
      link: { longUrl: null, shortUrl: null },
      partner: null,
      price: null,
      routes: [
        {
          id: uuid(),
          title: "",
          company: "",
          code: "",
          from: "",
          fromDetail: "",
          fromCode: "",
          fromPlace: null,
          to: "",
          toDetail: "",
          toCode: "",
          toPlace: null,
          start: null,
          end: null,
          stops: null,
          duration: {
            hours: null,
            minutes: null
          }
        }
      ]
    });
    this.syncExpanded(true);
  }
}
